var userAgent = navigator.userAgent.toLowerCase(); 

const productTitle = document.querySelector(".product-single__title");
const productText = productTitle.dataset.productTitle;
const splitTitle = productText
  .split(" ")
  .map(
    (c, i) => {
      if (userAgent.indexOf("safari") != -1) {
        if (userAgent.indexOf("chrome") > -1) {
          return `<div class="product-text__transition" style="animation-delay: ${
            i / 55
          }s; -webkit-animation-delay: ${i / 55}s;">${c}</div>`;
        } else {
          return `<div class="product-text__transition--safari">${c}</div>`;
        }
      }
    }
  );
const titleTemplate = `<div">${splitTitle.join(
  " "
)}</div>`;
productTitle.innerHTML = titleTemplate;